import { useState } from 'react';
import { Upload, Store } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/Button';
import { SplitButton } from '@/shared/components/ui/SplitButton';
import { ImportSignalModal } from './ImportSignalModal';
import { MarketplaceModal } from '../marketplace/MarketplaceModal';

interface KnowledgePageHeaderProps {
  onAddSignal: () => void;
}

export const KnowledgePageHeader = ({
  onAddSignal,
}: KnowledgePageHeaderProps) => {
  const { t } = useTranslation('knowledge');
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isMarketplaceOpen, setIsMarketplaceOpen] = useState(false);

  return (
    <>
      <div className="relative mx-4 sm:mx-6 lg:mx-8">
        <div className="mx-auto flex max-w-7xl items-center justify-between pb-6 pt-10">
          <h1 className="text-2xl font-bold text-gray-900">{t('pageTitle')}</h1>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              className="border-gray-300 bg-white"
              onClick={() => setIsMarketplaceOpen(true)}
            >
              <Store className="h-4 w-4" />
              {t('marketplace.browseMarketplace')}
            </Button>
            <SplitButton
              size="sm"
              className="bg-[#5E6AD2] hover:bg-[#4F5ABF]"
              onClick={onAddSignal}
              menuItems={[
                {
                  label: t('importFromFile'),
                  icon: <Upload className="h-4 w-4" />,
                  onClick: () => setIsImportModalOpen(true),
                },
              ]}
            >
              {t('addSignal')}
            </SplitButton>
          </div>
        </div>
      </div>

      <ImportSignalModal
        open={isImportModalOpen}
        onOpenChange={setIsImportModalOpen}
      />
      <MarketplaceModal
        open={isMarketplaceOpen}
        onOpenChange={setIsMarketplaceOpen}
      />
    </>
  );
};
